import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useResponsive } from "../../hooks/mediaQuery";
import { ListFilter } from 'lucide-react';
import { FilterField } from "../../models/types/common";
import PageFilter from "../../components/pageFilter";
import * as yup from "yup";
import { useTranslation } from "react-i18next";

const StandardFilter = () => {
    const { t } = useTranslation();
    const { isXs } = useResponsive();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const filterFields: FilterField[] = [
        {
            name: "name",
            type: "text",
            label: t('standard.filter.fields.name.label'),
            placeholder: t('standard.filter.fields.name.placeholder'),
        },
        {
            name: "description",
            type: "text",
            label: t('standard.filter.fields.description.label'),
            placeholder: t('standard.filter.fields.description.placeholder'),
        },
        {
            name: "issuedDateFromTo",
            type: "dateFromto",
            label: t('standard.filter.fields.issuedDate.label'),
            placeholder: t('standard.filter.fields.issuedDate.placeholder'),
        },
        {
            name: "effectiveDateFromTo",
            type: "dateFromto",
            label: t('standard.filter.fields.effectiveDate.label'),
            placeholder: t('standard.filter.fields.effectiveDate.placeholder'),
        },
        {
            name: "endDateFromTo",
            type: "dateFromto",
            label: t('standard.filter.fields.endDate.label'),
            placeholder: t('standard.filter.fields.endDate.placeholder'),
        }
    ];

    const filterSchema = yup.object({
        name: yup.string().nullable(),
        description: yup.string().nullable(),
        issuedDateFromTo: yup.array().of(yup.string().nullable()).nullable(),
        effectiveDateFromTo: yup.array().of(yup.string().nullable()).nullable(),
        endDateFromTo: yup.array().of(yup.string().nullable()).nullable(),
    });

    useEffect(() => {
        setIsOpen(!isXs);
    }, [isXs]);

    const onClose = () => {
        setIsOpen(false);
    };

    if (isXs) return (
        <>
            <div
                onClick={() => setIsOpen(true)}
                className="flex items-center gap-2 rounded-full border bg-indigo-600 p-[2px_12px_4px_12px] cursor-pointer"
            >
                <ListFilter size={16} color="white" />
                <span className="text-white">{t('standard.filter.button')}</span>
            </div>
            <Dialog
                open={isOpen}
                onClose={onClose}
                maxWidth="lg"
                fullWidth
                className='dialog_camera'
            >
                <DialogTitle className="!p-2">
                    {t('standard.filter.title')}
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 5,
                            top: 5,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ background: '#000' }}>
                    <PageFilter
                        fields={filterFields}
                        validationSchema={filterSchema}
                        onSuccess={onClose}
                    />
                </DialogContent>
            </Dialog>
        </>
    );
    return (
        <PageFilter
            fields={filterFields}
            validationSchema={filterSchema}
        />
    )
}

export default StandardFilter